import * as React from 'react';
import { ElementLoader } from 'ui';
import { MeatballMenu, PromptConfirmationModal } from 'ui';
import { ids } from 'app/area/administration/constants';
import { ItemPersonAccess } from 'app/area/administration/list/types-store';
import style from './person-meatball-menu.scss';
import { Link } from 'react-router-dom';

interface PersonMeatballMenuComponentProps {
  id: number;
  itemPersonAccess: ItemPersonAccess;
  labelDeleteTitle: string;
  labelCancel: string;
  labelContinue?: string;
  labelDelete: string;
  labelDescription: string;
  labelNoAccess: string;

  labelDuplicate?: string;
  canDuplicate?: boolean;

  onDuplicate: (id: number) => any;
  onDelete: (id: number) => void;
  onLoadPersonAccess: (id: number) => void;
  onClearPersonAccess: () => void;
  children?: React.ReactNode;
}

export const PersonMeatballMenu: React.FC<PersonMeatballMenuComponentProps> = (props) => {
  const { id, itemPersonAccess, labelDuplicate, labelDelete, labelDeleteTitle, labelCancel, labelDescription, labelContinue,
    labelNoAccess, onDelete, children } = props;

  const handleDelete = onDelete ? () => onDelete(id) : undefined;

  const canDelete = !!(itemPersonAccess && itemPersonAccess.access
    && itemPersonAccess.access.delete && handleDelete);

  const canDuplicate = !!(itemPersonAccess && itemPersonAccess.access
    && itemPersonAccess.access.edit) && props.canDuplicate && props.onDuplicate;

  const hasNoAccess = !canDelete && !canDuplicate;

  const handleLoadPersonAccess = () => props.onLoadPersonAccess(id);
  const handleClearPersonAccess = () => props.onClearPersonAccess();

  if (itemPersonAccess && itemPersonAccess.fetching) {
    return <MeatballMenu
      id={ids.list_search_item(id)}
      onExpandMenu={handleLoadPersonAccess}
      onCloseMenu={handleClearPersonAccess}>
      <div className={style.loader}>
        <ElementLoader />
      </div>
    </MeatballMenu>;
  }

  return <MeatballMenu
    id={ids.list_search_item(id)}
    onExpandMenu={handleLoadPersonAccess}
    onCloseMenu={handleClearPersonAccess}>
    {hasNoAccess
      ? <li>
        <p className={style.labelNoAccess}>
          {labelNoAccess}
        </p>
      </li>
      : <>
        {canDuplicate && <li>
          <Link
            to={props.onDuplicate(id)}
            className="dropdown-item">
            {labelDuplicate}
          </Link>
        </li>}
        <li>
          {canDelete &&
            <PromptConfirmationModal
              title={labelDeleteTitle}
              description={labelDescription}
              continueText={labelContinue ?? labelDelete}
              cancelText={labelCancel}
              onContinue={handleDelete}>
              <button type="button" className="dropdown-item">
                {labelDelete}
              </button>
            </PromptConfirmationModal>}
        </li>
        {
          children ?? null
        }
      </>}
  </MeatballMenu>;
};
